import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createAppCustomCssApi, appCustomCssRelativePath } from './';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
export var createAppCustomCssApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAppCustomCssApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGet: function () {
            return createFakeGetResponder(fakeHttp, "".concat(appCustomCssRelativePath));
        },
        whenUpdate: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(appCustomCssRelativePath))(dto.data);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map